/// <amd-module name="SuiteCommerce.Blog.DataProvider.Term.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.DataProvider.Term.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TermModel = /** @class */ (function (_super) {
        __extends(TermModel, _super);
        function TermModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(TermModel.prototype, "id", {
            get: function () {
                return this.get('id');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TermModel.prototype, "name", {
            get: function () {
                return this.get('name');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TermModel.prototype, "urlComponent", {
            get: function () {
                return this.get('urlComponent');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TermModel.prototype, "isUsed", {
            get: function () {
                return this.get('isUsed');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TermModel.prototype, "defaultAlias", {
            get: function () {
                return this.get('defaultAlias');
            },
            enumerable: true,
            configurable: true
        });
        return TermModel;
    }(Backbone_1.Model));
    exports.TermModel = TermModel;
});
